import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/legal.css';

const TermsPage = () => {
  const { t } = useTranslation();
  const sections = t('termsPage.sections', { returnObjects: true });

  return (
    <div className="legal-page">
      <div className="container">
        <h1>{t('termsPage.title')}</h1>
        <p className="legal-last-updated">{t('termsPage.lastUpdated')}</p>
        <p className="legal-intro">{t('termsPage.intro')}</p>

        {sections.map((section) => (
          <section key={section.title} className="legal-section">
            <h2>{section.title}</h2>
            {section.paragraphs.map((paragraph, idx) => (
              <p key={`${section.title}-${idx}`}>{paragraph}</p>
            ))}
          </section>
        ))}
      </div>
    </div>
  );
};

export default TermsPage;

